export default __webpack_public_path__ + "static/m-process-08-692e4c989eb9353e9272121ed4fd3daa.svg";